module.exports = __webpack_public_path__ + "img/ICBC.f6cddd7b.png";